import { Validator } from 'vee-validate'
import Vue from 'vue'

export default {
  ['SET_WHOLESALE_STATUS']: function (state, value) {
    state.isWholesale = value
  },
  ['SET_WHOLESALE']: function (state, value) {
    state.wholesale = value
  },
  ['SET_PRODUCT_IN_CART']: function (state, product) {
    Vue.set(state.cart[product.index], 'quantity', product.quantity)
  },
  ['SET_LANG']: function (state, payload) {
    Vue.i18n.set(payload)
    Validator.localize(payload)
  },
  ['SET_THEME_COLOR']: function (state, payload) {
    state.theme.color = payload ? payload : '#cecece'
    Vue.prototype.$vuetify.theme.primary = state.theme.color
    // Vue.vuetify.theme.primary = state.theme.color
    // Vue.$vuetify.theme.themes.light.primary = state.theme.color
  },
  ['SET_ALL_CART']: function (state, payload) {
    state.cart = payload
  },
  ['SET_INFLUENCER_ID']: function (state, payload) {
    state.influencerid = payload
    localStorage.setItem('influencerid', payload)
  },
  ['CLEAR_INFLUENCER_ID']: function (state) {
    state.influencerid = null
    localStorage.removeItem('influencerid')
  },
  ['ADD_CART']: function (state, payload) {
    state.cart.push(payload)
  },
  ['EDIT_QUANTITY']: function (state, payload) {
    state.cart[payload.index].quantity = payload.quantity
  },
  ['UPDATE_BUNDLE_CART']: function (state, payload) {
    state.cart.forEach(function (product, index) {
      var bundles = []
      bundles = payload.filter(function (bundle) {
        if (bundle.productid == product.id) {
          return bundle
        }
      })
      Vue.set(state.cart[index], 'productbundle', bundles)
    })
  },
  ['GET_SALEPAGE']: function (state, payload) {
    state.salePage = payload
  },
  ['EDIT_ADDON_JSON']: function (state, payload) {
    if (state.cart[payload.index].addon_json.hasOwnProperty(payload.name))
      Vue.set(
        state.cart[payload.index].addon_json,
        payload.name,
        payload[payload.name]
      )
  },
  ['EDIT_ALL_ADDON_JSON']: function (state, payload) {
    const index = state.cart.findIndex(
      (product) => product.rand_id == payload.rand_id
    )
    if (index != -1) {
      Vue.set(state.cart[payload.index], 'addon_json', payload.addon_json)
    }
  },
  ['SET_CART_ID']: function (state, payload) {
    state.cart_ids = payload
  },
  ['SET_SHOP_MAIN_PRODUCT']: function (state, payload) {
    state.shop_main_pageid = payload
    localStorage.setItem('shop_main_pageid', payload)
  },
  ['REMOVE_SHOP_MAIN_PRODUCT']: function (state) {
    state.shop_main_pageid = null
    localStorage.removeItem('shop_main_pageid')
  },
  ['SET_VOUCHERS']: function (state, payload) {
    state.vouchers = payload
  },
  ['SET_HAS_AUTO_SELECT_VOUCHER']: function (state, payload) {
    state.hasAutoSelectVoucher = payload
  },
  setPaysolutionCustomerData: function (state, payload) {
    state.paysolutionCustomerData = payload
  },
  setPaymentGatewayData: function (state, payload) {
    state.paymentGatewayData = payload
  },
  setPaymentGateways: function (state, payload) {
    state.paymentGateways = payload
  }
}
